import { useContext, useEffect, useState } from 'react';
import { SupervisorContext } from '@/contexts/SupervisorContext';
import { getTimerDisplay, normalizeTimerDisplay, TimerDisplay } from '@/utils/timerDisplay';

/**
 * Aktivitetsklockans form och siffror i den vy som renderas nu.
 *
 * Valet ägs av HANDLEDAREN och bor på brukarens konto (users.timer_display_shape /
 * timer_display_digits). Här finns två källor, och ordningen är det som gör vyn sann:
 *
 *  1. Handledarläge med vald brukare → BRUKARENS värde (currentClient), för då visar
 *     vyn brukarens dag. Utan detta hade handledaren sett sin egen klocka i
 *     förhandsvisningen och trott att inställningen inte gick igenom.
 *  2. Annars → det egna kontots värde, speglat i localStorage av AppContext.
 *     Spegeln läses live via 'storage' (samma mönster som useNpfNudgePrefs och
 *     useEffectiveChildMode) så att en ändring slår igenom utan omladdning.
 */
export const useTimerDisplay = (): TimerDisplay => {
  const [display, setDisplay] = useState<TimerDisplay>(getTimerDisplay);
  const { currentClient } = useContext(SupervisorContext);

  useEffect(() => {
    const handleStorageChange = () => setDisplay(getTimerDisplay());

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  if (currentClient) {
    return normalizeTimerDisplay(currentClient.timerDisplayShape, currentClient.timerDisplayDigits);
  }
  return display;
};
